import { memo } from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { RedesignSignInWithProviderButton } from 'root/src/client/v2/auth/redesign/RedesignSignInWithProviderButton';
import { ScopeSet } from 'root/src/shared/@types/auth';
import { Provider } from 'root/src/shared/@types/providers';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
export const RedesignChatPermissionModal = memo(({ onGranted, onCancel }) => (<RedesignModalShell className="sm:max-w-md">
		<div className="flex w-full flex-col items-center gap-3 text-center">
			<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-cyan/30 bg-neon-cyan/10">
				<ChatBubbleOutlineIcon sx={{ fontSize: 24 }} className="text-neon-cyan"/>
			</div>
			<h2 className="font-display text-xl font-bold text-foreground">Permission needed</h2>
			<p className="text-sm text-muted-foreground">
				To share announcements in your chat, we need extra permissions on your Twitch account. Re-authenticate to grant access.
			</p>
		</div>

		<RedesignSignInWithProviderButton provider={Provider.Twitch} scopeSet={ScopeSet.creatorPlus} popup popupOptions={{
        onSuccess: () => onGranted(),
        onError: (error) => {
            toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
            onCancel();
        },
    }}/>

		<Button variant="ghost" size="sm" onClick={onCancel} className="rounded-lg text-sm">Cancel</Button>
	</RedesignModalShell>));
